import { render, staticRenderFns } from "./manifest.vue?vue&type=template&id=01123dfa&scoped=true&"
import script from "./manifest.vue?vue&type=script&lang=js&"
export * from "./manifest.vue?vue&type=script&lang=js&"
import style0 from "./manifest.vue?vue&type=style&index=0&id=01123dfa&lang=less&scoped=true&"
import style1 from "./manifest.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01123dfa",
  null
  
)

export default component.exports